// extracted by mini-css-extract-plugin
module.exports = {"header":"DeclineModal_header__2PW5q","buttonYes":"DeclineModal_buttonYes__32nK0"};